import { apiClient as api } from './apiClient';

export interface FarmaciaLookup {
  id: number;
  _Name: string;
}

export interface ProvinciaLookup {
  id: number;
  provincia: string;
}

export interface ClienteLookup {
  id: number;
  _Name: string;
  codigoGF?: string;
}

export interface EmpleadoLookup {
  id_Empleado: number;
  nombreAbreviado: string;
}

export interface TransmisionVendedor {
  transmisionId: number;
  vendedorId: number;
  cliente?: ClienteLookup;
}

export interface TransmisionComprador {
  transmisionId: number;
  compradorId: number;
  cliente?: ClienteLookup;
}

export interface Transmision {
  id: number;
  responsableId: number;
  fechaCreacion: string;
  fechaModificacion?: string;
  modificadorId?: number;
  farmaciaId: number;
  tramoFact?: number;
  horario?: number;
  localRegimenId?: number;
  notas?: string;
  notasGestion?: string;
  fecha: string;
  precio?: number;
  factor?: number;
  empresaId?: number;
  estadoId?: number;
  enVenta_Exclusiva?: boolean;
  enVentaDesde?: string;
  enVentaHasta?: string;
  provinciaId?: number;
  origen?: string;
  vendedores: TransmisionVendedor[];
  compradores: TransmisionComprador[];
  // Lookup data
  farmacia?: FarmaciaLookup;
  provincia?: ProvinciaLookup;
  responsable?: EmpleadoLookup;
}

export interface UpdateEstadoRequest {
  estadoId: number;
}

export interface UpdateTransmisionRequest {
  fecha: string;
  estadoId: number;
  notasGestion?: string;
}

export interface AsesorOption {
  id: number;
  nombre: string;
}

export const getAsesores = async (): Promise<AsesorOption[]> => {
  try {
    const response = await api.get('/transmisiones/asesores');
    return response.data;
  } catch (error) {
    console.error('Error fetching asesores:', error);
    return [];
  }
};

export const getTransmisiones = async (estadoId?: number): Promise<Transmision[]> => {
  try {
    const url = estadoId !== undefined ? `/transmisiones?estadoId=${estadoId}` : '/transmisiones';
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching transmisiones:', error);
    throw error;
  }
};

export const getTransmisionesPendientes = async (): Promise<Transmision[]> => {
  try {
    const response = await api.get('/transmisiones/pendientes');
    return response.data;
  } catch (error) {
    console.error('Error fetching transmisiones pendientes:', error);
    throw error;
  }
};

export const getTransmisionById = async (id: number): Promise<Transmision> => {
  try {
    const response = await api.get(`/transmisiones/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching transmision ${id}:`, error);
    throw error;
  }
};

export const updateEstado = async (id: number, estadoId: number): Promise<void> => {
  try {
    await api.put(`/transmisiones/${id}/estado`, { estadoId });
  } catch (error) {
    console.error(`Error updating estado for transmision ${id}:`, error);
    throw error;
  }
};

export const updateTransmision = async (id: number, fecha: string, estadoId: number, notasGestion?: string): Promise<void> => {
  try {
    await api.put(`/transmisiones/${id}`, { fecha, estadoId, notasGestion });
  } catch (error) {
    console.error(`Error updating transmision ${id}:`, error);
    throw error;
  }
};

export const createTransmision = async (transmision: Omit<Transmision, 'id' | 'fechaCreacion'>): Promise<Transmision> => {
  try {
    const response = await api.post('/transmisiones', transmision);
    return response.data;
  } catch (error) {
    console.error('Error creating transmision:', error);
    throw error;
  }
};

export const refreshTransmisiones = async (estadoId?: number): Promise<Transmision[]> => {
  try {
    const url = estadoId !== undefined ? `/transmisiones/refresh?estadoId=${estadoId}` : '/transmisiones/refresh';
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error('Error refreshing transmisiones:', error);
    throw error;
  }
};
